import { sortByName } from "common/utils/sorting";
import { IService } from "dataSources/Typicode/common/types";
import { FUEL_CODE } from "shared/constants";

export const getFuelListFServicesWithoutGroup = (items: IService[]) => {
  const fuelGroups = items.find((item) => Number(item.code) === FUEL_CODE);

  const queue: IService[] = [...(fuelGroups?.children || [])];
  const fuelServices: IService[] = [];

  while (queue.length > 0) {
    const node = queue.pop();
    if (node?.children?.length === 0) {
      fuelServices.push(node);
      continue;
    }

    node?.children?.forEach((node) => queue.push(node));
  }

  return fuelServices.sort(sortByName);
};
